import { Icon } from '@factorialco/deprecated-design-system'
import {
  FinancialWorkspaceValueObjectsInsightTableGroupEnum,
  FinancialWorkspaceValueObjectsInsightTableTypeEnum,
  FinancialWorkspaceValueObjectsPeriodEnum,
  Maybe,
  PayrollValueObjectsConceptCategoryEnum,
} from 'generated/resources/graphql'

export const SUMMARIZED_VALUES = 'summarized_values'

export type TableDataVariables = {
  after?: string | null
  formattedEndDate: string
  formattedStartDate: string
  formattedCompareToEndDate: string
  formattedCompareToStartDate: string
  period: FinancialWorkspaceValueObjectsPeriodEnum
  legalEntityIds?: number[]
  itemsPerPage?: number
  costCenterIds?: number[]
  locationIds?: number[]
  conceptIds?: number[]
  employeeIds?: number[]
  search?: string
  offset?: number
  insightTableType:
    | FinancialWorkspaceValueObjectsInsightTableTypeEnum
    | 'employee_costs'
    | 'compensation'
  groupBy: FinancialWorkspaceValueObjectsInsightTableGroupEnum
  includeFuturePeriods?: boolean
  resetPagination?: () => void
}

export interface TableItemData {
  label: string
  range: string
  isUngrouped?: boolean
  isSummarized?: boolean
  totalAmountInCents: string
  totalAmountWithPrecision?: string
  period: FinancialWorkspaceValueObjectsPeriodEnum
}

export type PaginatedTableItemPriority = 'high' | 'normal'

interface CustomRow {
  component: React.FC<{
    headerLength: number
    tableHeadRef?: React.RefObject<HTMLTableSectionElement>
    level?: number
  }>
  visible: boolean
}

interface CustomChildren {
  component: React.FC<{
    level: number
    id: string | number
    headerLength: number
    groupBy: InsightTableGroupBy
    parentHasItemWithChildren?: boolean
    setParentHasItemWithChildren?: (value: boolean) => void
    tableHeadRef?: React.RefObject<HTMLTableSectionElement>
  }>
}

export interface PaginatedTableItem {
  grey?: boolean
  italic?: boolean
  dashed?: boolean
  tooltip?: string
  active?: boolean
  subLabel?: string
  loading?: boolean
  expanded?: boolean
  id: number | string
  label?: string | null
  customRow?: CustomRow
  data: TableItemData[]
  isUngrouped?: boolean
  isSummarized?: boolean
  imageUrl?: string | null
  onLazyChildren?: LazyChildren
  categoryLabel?: string | null
  children?: PaginatedTableItem[]
  comparisonData?: TableItemData[]
  customChildren?: CustomChildren[]
  priority?: PaginatedTableItemPriority
  titleWrapper?: React.FC<{ children: React.ReactNode }>
  iconLabel?: React.ComponentProps<typeof Icon.Medium>['icon']
  category?: Maybe<PayrollValueObjectsConceptCategoryEnum> | string
}

export interface HeaderData {
  label: string
  chartLabel?: string
  value: moment.Moment
  onClick?: ClickHeader
}

export type ClickHeader = (value: moment.Moment) => void

export interface TableProps {
  loading: boolean
  items: PaginatedTableItem[]
  showPagination?: boolean
  totalCount: number
  headers: string[] | HeaderData[]
  hasNextPage: boolean
  endCursor?: string | null
  refetch: () => void
}

export enum InsightTableType {
  Payroll = 'payroll',
  EmployeeCosts = 'employee_costs',
  Compensation = 'compensation',
}

export type LazyChildren = (id: string | number) => Promise<{
  data: PaginatedTableItem[]
  loading: boolean
}>

export enum InsightTableGroupBy {
  LegalEntity = 'legalentity',
  Manager = 'manager',
  CostCenter = 'costcenter',
  Location = 'location',
  LineItem = 'lineitem',
  Total = 'total',
  Employee = 'employee',
  CustomCategory = 'customcategory',
}

export enum InsightTablePeriod {
  Yearly = 'yearly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Weekly = 'weekly',
  Daily = 'daily',
}
